package puzzlekey

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

/** The Scan model in `model/` (ADR-0009): `model/export.py` writes it; `seal` and the site run the same file. */
const val MODEL_FILE = "mobilenet_v3_large.onnx"

/** The public centre vector next to [MODEL_FILE]. */
const val CENTRE_FILE = "centre.json"

/** [CENTRE_FILE]: the mean L2-normalised embedding of generic photos, never the corpus (ADR-0009 §1), and the model it is for. */
@Serializable
class CentreFile(val model: String, val images: String, val centre: FloatArray) {
    companion object {
        fun parse(text: String): CentreFile = Json.decodeFromString(serializer(), text)
    }
}
